export default __webpack_public_path__ + "static/media/success_error.fd6caeb4.png";